/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {RootState} from "../../../../reducer/reducer"
import {LOG_OUT} from '../../../../actions'

const HeaderUserMenu: FC = () => {
  // const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const UserInfo = useSelector((state:RootState) => {
    return state.UserInfo
  })
  console.log('user info redux', UserInfo)
  const dispatch = useDispatch()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div  className='menu-item px-3'>
        <div className='menu-content d-flex flex-row-reverse align-items-center px-3'>
          {UserInfo.UserInfo && (
            <div className='d-flex flex-column'>
              <div dir={'rtl'} className='fw-bolder d-flex align-items-center fs-5'>
                {/*{user.firstname} {user.lastname}*/}
                {UserInfo.UserInfo.name}
                {/*<span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>*/}
              </div>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {/*{user.email}*/}
                {UserInfo.UserInfo.email}
              </a>
            </div>
          )}
        </div>
      </div>

      <div className='separator my-2'></div>

      <div  dir='rtl' className='menu-item px-5 text-right flex justify-end'>
        <Link to={'/crafted/account'} className='menu-link text-right px-5'>
           -حساب کاربری
        </Link>
      </div>

      {/*<div dir='rtl' className='menu-item px-5 text-right flex justify-end'>*/}
      {/*  <a href='#' className='menu-link px-5'>*/}
      {/*    <span className='menu-text'>وضعیت سهام  </span>*/}
      {/*    <span className='menu-badge'>*/}
      {/*      <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>*/}
      {/*    </span>*/}
      {/*  </a>*/}
      {/*</div>*/}

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >


        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='separator my-2'></div>
        </div>
      </div>

      <div dir='rtl' className='menu-item px-5'>
        <Link  to={'/finance'} className='menu-link px-5'>
          وضعیت پرداخت
        </Link>
      </div>

      <div className='separator my-2'></div>

      {/*<Languages />*/}

      {/*<div className='menu-item px-5 my-1'>*/}
      {/*  <Link to='/crafted/account/settings' className='menu-link px-5'>*/}
      {/*    Account Settings*/}
      {/*  </Link>*/}
      {/*</div>*/}

      <div  dir='rtl' className='menu-item px-5'>
        {/*<a onClick={logout} className='menu-link px-5'>*/}
        <a onClick={() => dispatch(LOG_OUT())} className='menu-link px-5'>
           خروج
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
